import SweepManager from "./mp/sweep-manager";
import SceneManager from "./mp/scene-manager";
import sweepButtons from "./components/sweep-button";
import siteMapOverlay from "./components/site-map-overlay";

import query from './supports/query';
import ready from './supports/ready';
import select from './supports/select';
import throttle from './supports/throttle';
import wait from './supports/wait';

import { Navigation } from "@nf/matterport-ui/src/js/index"

import { parseScene } from "./utils/scene";
import { getSweepParam } from "./utils/sweep";

// Set Globals
window.query = query;
window.ready = ready;
window.select = select;
window.throttle = throttle;
window.wait = wait;

function getSdk(iframe) {
    return new Promise((resolve, reject) => {
        iframe.addEventListener("load", async () => {
            const win = iframe.contentWindow;

            try {
                const sdk = await win.MP_SDK.connect(win);
                sdk.App.state.subscribe(state => {
                    if (state.phase == "appphase.playing") {
                        resolve(sdk);
                    }
                });
            } catch (err) {
                reject(err);
            }
        });
    });
}
window.getSdk = getSdk;

window.mpSdk = (async () => {
    const showcase = document.getElementById("showcase");
    const sdk = await getSdk(showcase);

    // Handle Horizontal Scrollbars
    query('[data-scroll="horizontal"]', (scrollbar) => {
        scrollbar.addEventListener('wheel', (event) => {
            event.preventDefault();
            scrollbar.scrollLeft += event.deltaY;
        });
    });

    // Handle Locate Buttons
    query('[data-handle="locate"]', (locate) => {
        locate.addEventListener('click', (event) => {
            event.preventDefault();
            let data = locate.hash.slice(1);
            let [sweep, rotation] = data.split('@');
            rotation = rotation.split(':');

            sdk.Sweep.moveTo(sweep, {
                transition: "transition.fly",
                transitionTime: 1000,
                rotation: { 
                    x: parseFloat(rotation[0]), y: parseFloat(rotation[1]) 
                },
            });
        });
    });

    // Handle Navbar
    const navbar = select('[data-handle="navbar"]');
    if (navbar) {
        new Navigation(navbar);
    }

    // Start UI
    siteMapOverlay({
        button: 'site-map-button',
        overlay: "site-map-overlay",
        map: "site-map",
        description: {
            originalTitle: "site-map-title",
            root: "site-map-description",
            open: "site-map-description-open",
            close: "site-map-description-close",
            head: "site-map-description-head",
            body: "site-map-description-body",
            title: "site-map-description-title",
        }
    });

    const sweepManager = new SweepManager(sdk);
    const sceneManager = SceneManager.fromJSON(sdk, parseScene());

    const ctx = {
        sdk,
        sweepManager,
        sceneManager,
    };

    if (development) {
        //import("./dev-tools")
        //    .then(module => module.devTools(sdk));
    }

    // Handle parameter for initial sweep
    const sweepParam = getSweepParam();
    if (sweepParam) {
        const [sid, rotX, rotY] = sweepParam;
        sdk.App.state.subscribe(state => {
            if (state.phase === sdk.App.Phase.PLAYING) {
                setTimeout(() => {
                    sdk.Sweep.moveTo(sid, {
                        rotation: { x: rotX, y: rotY },
                        transition: sdk.Sweep.Transition.FADEOUT,
                    });
                }, 500);
            }
        });
    }

    sweepButtons(ctx, "button[data-sweep]");

    // Parse runtime configuration
    let runtimeConfig = {
        hide_unknown: true,
    };

    {
        const runtimeConfigEl = document.getElementById("runtime");
        if (runtimeConfigEl) {
            runtimeConfig = { runtimeConfig, ...JSON.parse(runtimeConfigEl.textContent) };
        }
    }

    // Hide unknown sweeps
    if (!development && runtimeConfig.hide_unknown) {
        ctx.sweepManager.hideUnknown();
    }

    return sdk;

})();
